import React from 'react';
import Block from '../Block';
import WysiwygField from '../WysiwygField';

import './style.scss';

interface Props {
  title: string;
  body: string;
  webform?: React.ReactNode;
  image?: React.ReactNode;
}

const BlockContactForm: React.FC<Props> = ({
  title,
  body,
  webform,
  image,
}) => {
  return (
    <Block className="BlockContactForm">
      <div className="row">
        <div className="col-md-6">
          {image && (
            <div className="BlockContactForm__image">
              {image}
            </div>
          )}
          <h2>{title}</h2>
          <WysiwygField
            property="schema:text"
            html={body}
          />
        </div>
        {webform && (
          <div className="col-md-6">
            {webform}
          </div>
        )}
      </div>
    </Block>
  );
};

export default BlockContactForm;
